import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconCheck, IconDownload, IconVersion } from '../../../../../../shared/icon/icon'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { useDownloadPresign } from '../../../../../../shared/download/hook'
import { useApiFormAssetVersion, useApiListAssetVersion } from '../../../../../../api-new/state/content'
import { ColumnDateTime, ColumnFormat, ColumnMenu, ColumnSize, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'
import { Menu, MenuDelete, MenuEdit, MenuItem, MenuRecycle } from '../../../../../../shared/menu/menu'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { AssetVersionEdit } from './asset-version-edit'
import { AssetVersionlistRecycle } from './asset-version-list-recycle'
import { Delete } from '../../../../../../shared/page/page-delete'

const formatBytes = (bytes) => {
  if (!bytes || bytes === 0) return '0 KB'
  if (bytes >= 1073741824) return `${(bytes / 1073741824).toFixed(2)} GB`
  if (bytes >= 1048576) return `${(bytes / 1048576).toFixed(2)} MB`
  return `${(bytes / 1024).toFixed(2)} KB`
}

export const AssetVersionlist = () => {
  const { assetID } = useParamsInt()

  const { url } = useRouteMatch()

  const apiListAssetVersion = useApiListAssetVersion()

  const roleOrgNode = useRoleOrgNode()

  const { active, download } = useDownloadPresign()

  const handleReady = () => apiListAssetVersion.get(`${assetID}/asset`)
  const handleDestroyed = () => apiListAssetVersion.init()

  const handleSetCurrent = async id => {
    await apiListAssetVersion.put(`${id}/current`)
    await apiListAssetVersion.get(`${assetID}/asset`)
  }

  const handleDownload = async id => {
    let presigned = await apiListAssetVersion.get(`${id}/presigned-download`)
    download(presigned.url)
  }

  const roleSysApp = useRoleSysApp()

  const HeaderMenu = () =>
    <Menu>
      <MenuRecycle to={`${url}/${assetID}/recycle`} show={true} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconVersion} text="Asset versions">
        <CardFullHeightScrollY title="Asset versions" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAssetVersion} sortCol="versionCount" sortDesc onReady={handleReady} onDestoryed={handleDestroyed} pollInterval={5000}>
            <ColumnText field="versionCount" header="Version" />
            <ColumnDateTime field="createdAt" />
            <ColumnText field="filename" />
            <ColumnText field="storageKey" />
            <ColumnFormat field="contentLength" header="Size" render={row => {
              const d = row.data
              if (d.status === 'complete' || !d.bytesTransferred) return formatBytes(d.contentLength)
              return `${formatBytes(d.bytesTransferred)} / ${formatBytes(d.contentLength)}`
            }} />
            <ColumnYesNo field="isCurrent" header="Active" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="note" header="Notes" />
            <ColumnText field="status" header="Status" />
            <ColumnText field="statusReason" header="Reason" />
            <ColumnText field="statusMessage" header="Message" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem
                    Icon={IconCheck}
                    text="set active"
                    onClick={() => handleSetCurrent(row.id)}
                    show={roleOrgNode.accessUpdate}
                    disabled={row.status !== 'complete'}
                  />
                  <MenuItem Icon={IconDownload} text="download" onClick={() => handleDownload(row.id)} show={roleOrgNode.accessRead} disabled={active} />
                  <MenuEdit to={`version/edit/${row.id}`} show={roleSysApp.accessUpdate} />
                  <MenuDelete to={`version/${row.id}/delete`} show={roleOrgNode.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/edit/:assetVersionID`}>
        <AssetVersionEdit parentURL={url} />
      </Route>

      <Route path={`${url}/:assetID/recycle`}>
        <AssetVersionlistRecycle />
      </Route>

      <Route path={`${url}/:deleteID/delete`}>
        <Delete useApiForm={useApiFormAssetVersion} titleParam="filename" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
